import axios from 'axios';

// Define API locally from env to avoid a circular import with App.js
// (re-exporting App's `API` at module load triggered a TDZ error).
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const authHdr = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

// Effective-capability check mirroring the backend: owner / admin.controls => all.
export const canOps = (user, cap) => {
  if (!user) return false;
  if (user.role === 'owner' || (user.capabilities || []).includes('admin.controls')) return true;
  const caps = user.capabilities || [];
  if (caps.includes(cap)) return true;
  // section children are implied by the parent workspace only when explicitly granted;
  // we keep the explicit-cap rule here to match the restricted UI intent.
  return false;
};

export const money = (v) => {
  if (v === null || v === undefined) return null;
  const n = Number(v);
  if (Number.isNaN(n)) return null;
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

// Authenticated file download (PDF / Excel) — keeps the bearer token on the request.
export const downloadFile = async (url, token, filename) => {
  const res = await axios.get(url, { ...authHdr(token), responseType: 'blob' });
  const blob = new Blob([res.data], { type: res.headers['content-type'] });
  const href = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href; a.download = filename;
  document.body.appendChild(a); a.click();
  a.remove(); window.URL.revokeObjectURL(href);
};

export { axios };
